<template>
  <div id="second" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord.status==1"> 
      <el-alert
        title="已超過開放成績查詢時間!!"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
    <div v-else-if="docRecord!=null && docRecord.status==2">
      <div class="">
          <table class="w-100" style="background-color: azure;border: gray;"  rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="4" class="ncut-base-form-title" style="background-color: orange; text-align: left; padding: 0.5em;">複試成績查詢結果如下:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" colspan="4" style="text-align: left; padding: 0.5em;">
                  報考類別：{{docRecord.groupName}}
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="width: 12%;">考生姓名</td>
                <td style="padding:0.5em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 12%;">報名編號</td>
                <td style="padding:0.5em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord.regNo}}</span>
                </td>
              </tr>
              <tr v-if="null == docRecord.gTitle">
                <td class="ncut-base-form-title">原始總分</td>
                <td colspan="3" style="padding:0.5em;">
                  <span class="badge badge-primary" style="font-size:1.25rem">{{docRecord.originalGrade | numFilter}}</span>
                </td>
              </tr>
              <tr v-for="(item,index) in docRecord.gTitle" :key="index" :index="index" :name="'G'+index">
                <td class="ncut-base-form-title">{{item}}</td>
                <td colspan="3" style="padding:0.5em;">
                  <span class="badge badge-primary" style="font-size:1.25rem">{{docRecord.gValue[index] | numFilter}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">實得總分</td>
                <td colspan="3" style="padding:0.5em;">
                  <span class="badge badge-success" style="font-size:1.5rem">{{(docRecord.admStatus == 2? '初試通過, 擇優錄取': (docRecord.admStatus == 9? '複試缺考': parseFloat(docRecord.totalGrade).toFixed(2)))}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">預估排名</td>
                <td colspan="3" style="padding:0.5em;">
                  <span class="badge badge-success" style="font-size:1.5rem">{{(docRecord.admStatus == 2? '初試通過, 擇優錄取': (docRecord.admStatus == 9? '複試缺考': docRecord.estRanking))}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="3" style="padding: 0.5em;">
                  <div style="white-space: pre-line; ">{{docRecord.memo}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <el-row style="padding: 1em 0 0;"
            v-if="docRecord.admStatus == 1 || docRecord.admStatus == 3 || docRecord.admStatus == 4 || docRecord.admStatus == 5 || docRecord.admStatus == 6">
            <el-button type="primary" @click="print(user.hId)">通知單下載<i class="el-icon-view"></i></el-button>
            <a :href="'./WebApi/Apply/GetSecondGradePDF/'.concat(user.hId).concat('/2')" class="ncut-btn-type"><span class="glyphicon glyphicon-download-alt" style="margin-right: 4px;" />通知單下載<i class="el-icon-download"></i></a>
          </el-row>
      </div>
    </div> 
    <div v-else-if="docRecord!=null && docRecord.status==5">
      <el-alert
        title="請先完成網路報名。"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>

<script>
export default {
  name: 'second',
  data () {
    return {
      docRecord: null
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    print(dId) {
      let url = './WebApi/Apply/GetSecondGradePDF/'.concat(dId).concat('/2');
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    }
  },
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2)
      return parseFloat(realVal)
    }
  },
  created () { 
    console.log('======created GradeView=====');
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetGradeInfo/'.concat(this.user.hId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = response.data
          } else {
            //vm.$message.error('對不起,讀取成績資料失敗');
            vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,讀取<i style="background:yellow;">成績資料</i>失敗</strong>',
                              offset: 150
                            });
           }
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SecondView.vue